import { supabase } from './supabase';

const getEmailFromIdentifier = (identifier: string) => {
  return identifier.includes('@') ? identifier : `${identifier.replace(/\D/g, '')}@chocolatevibes.app`;
};

export const signUp = async (identifier: string, password: string, fullName: string, phone: string) => {
  const email = getEmailFromIdentifier(identifier);
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: {
        full_name: fullName,
        phone,
      },
    },
  });

  if (error) throw error;

  // Profile is automatically created by the `handle_new_user` DB trigger.
  // Update the profile with the phone number (trigger only sets email, full_name, avatar_url).
  if (data.user) {
    await supabase.from('profiles').update({ phone }).eq('id', data.user.id);
  }

  return data;
};

export const signIn = async (identifier: string, password: string) => {
  const email = getEmailFromIdentifier(identifier);
  return await supabase.auth.signInWithPassword({
    email,
    password,
  });
};

export const signInWithMagicLink = async (email: string) => {
  const { data, error } = await supabase.auth.signInWithOtp({
    email,
    options: {
      emailRedirectTo: `${window.location.origin}/`,
    },
  });

  if (error) throw error;
  return data;
};

export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
};

export const resetPassword = async (email: string) => {
  const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${window.location.origin}/reset-password`,
  });

  if (error) throw error;
  return data;
};

export const updateProfile = async (userId: string, updates: Partial<{
  full_name: string;
  phone: string;
  address: Array<{
    id: string;
    label: string;
    street: string;
    city: string;
    postal_code?: string;
    area?: string;
    is_default: boolean;
    type: 'home' | 'work' | 'other';
  }>;
  avatar_url: string;
  preferred_language: 'bn' | 'en';
}>) => {
  const { data, error } = await supabase
    .from('profiles')
    .update(updates)
    .eq('id', userId)
    .select()
    .single();

  if (error) throw error;
  return data;
};
